/* iCase: muestra/oculta elementos programados por fecha, dias y horario (hora de Uruguay) */
(function () {
  'use strict';
  var TZ = 'America/Montevideo';
  var DAYMAP = { dom: 0, lun: 1, mar: 2, mie: 3, jue: 4, vie: 5, sab: 6 };

  function clean(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
  }
  function now() {
    try {
      var f = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, year: 'numeric', month: '2-digit', day: '2-digit', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false });
      var p = {};
      f.formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      var wd = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 }[p.weekday];
      var h = Number(p.hour) % 24;
      return { ymd: Number(p.year + p.month + p.day), day: wd, min: h * 60 + Number(p.minute) };
    } catch (e) {
      var d = new Date();
      return { ymd: d.getFullYear() * 10000 + (d.getMonth() + 1) * 100 + d.getDate(), day: d.getDay(), min: d.getHours() * 60 + d.getMinutes() };
    }
  }
  function parseDate(s) {
    s = clean(s);
    if (!s) return null;
    var m = s.match(/^(\d{1,2})[\/.-](\d{1,2})[\/.-](\d{4})$/);
    if (m) return Number(m[3]) * 10000 + Number(m[2]) * 100 + Number(m[1]);
    m = s.match(/^(\d{4})-(\d{1,2})-(\d{1,2})$/);
    if (m) return Number(m[1]) * 10000 + Number(m[2]) * 100 + Number(m[3]);
    return null;
  }
  function dayNum(tok) { var k = tok.slice(0, 3); return DAYMAP.hasOwnProperty(k) ? DAYMAP[k] : null; }
  function parseDays(s) {
    s = clean(s);
    if (!s || s === 'todos') return null;
    s = s.replace(/\s+(a|al|hasta)\s+/g, '-').replace(/\s*-\s*/g, '-');
    var set = {};
    s.split(/[,;\s]+/).forEach(function (tok) {
      if (!tok) return;
      var parts = tok.split('-');
      if (parts.length === 2) {
        var a = dayNum(parts[0]), b = dayNum(parts[1]);
        if (a === null || b === null) return;
        var i = a;
        for (var n = 0; n < 7; n++) { set[i] = true; if (i === b) break; i = (i + 1) % 7; }
      } else {
        var d = dayNum(tok);
        if (d !== null) set[d] = true;
      }
    });
    return set;
  }
  function parseTime(s) {
    s = clean(s).replace('hs', '').replace('h', '').trim();
    if (!s) return null;
    var m = s.match(/^(\d{1,2})(?::(\d{2}))?$/);
    return m ? Number(m[1]) * 60 + Number(m[2] || 0) : null;
  }
  function inRanges(txt, min) {
    txt = clean(txt);
    if (!txt || txt === '*' || txt === 'todo el dia') return true;
    var ok = false;
    txt.split(/[,;]+/).forEach(function (r) {
      var p = r.split(/\s*(?:-|a)\s*/);
      if (p.length < 2) return;
      var f = parseTime(p[0]), t = parseTime(p[1]);
      if (f === null || t === null) return;
      if (f <= t ? (min >= f && min < t) : (min >= f || min < t)) ok = true;
    });
    return ok;
  }
  function weekActive(week, n) {
    if (!week || week === 'none') return false;
    var today = n.day === 0 ? 7 : n.day, found = null;
    week.split(';').forEach(function (e) {
      var i = e.indexOf('=');
      if (i > 0 && Number(e.slice(0, i)) === today) found = e.slice(i + 1);
    });
    return found !== null && inRanges(found, n.min);
  }
  function isActive(el, n) {
    var start = parseDate(el.getAttribute('data-start'));
    var end = parseDate(el.getAttribute('data-end'));
    if (start && n.ymd < start) return false;
    if (end && n.ymd > end) return false;
    if (el.hasAttribute('data-week')) return weekActive(el.getAttribute('data-week'), n);
    var days = parseDays(el.getAttribute('data-days'));
    if (days && !days[n.day]) return false;
    var from = parseTime(el.getAttribute('data-from'));
    var to = parseTime(el.getAttribute('data-to'));
    if (from === null && to === null) return true;
    if (from === null) from = 0;
    if (to === null) to = 1440;
    return from <= to ? (n.min >= from && n.min < to) : (n.min >= from || n.min < to);
  }
  /* Etiquetas promocionales: se dibujan a partir de la seccion "Etiquetas promocionales" */
  var promos = null;
  function loadPromos() {
    if (promos) return promos;
    var el = document.getElementById('icase-promo-labels');
    try { promos = el ? JSON.parse(el.textContent) : []; } catch (e) { promos = []; }
    return promos;
  }
  function renderPromos() {
    var hosts = document.querySelectorAll('[data-promo-host]:not([data-promo-done])');
    if (!hosts.length) return;
    var list = loadPromos();
    hosts.forEach(function (host) {
      host.setAttribute('data-promo-done', '');
      var ctx = host.getAttribute('data-ctx') || 'page';
      var tags = host.getAttribute('data-tags') || '', cols = host.getAttribute('data-cols') || '';
      list.forEach(function (p) {
        if (ctx === 'card' ? !p.card : !p.page) return;
        var match = (p.c && cols.indexOf(p.c) > -1) || (p.g === 'todos') || (p.g && tags.indexOf('|' + p.g + '|') > -1);
        if (!match) return;
        var b = document.createElement('span');
        b.className = 'badge badge--promo';
        b.setAttribute('data-schedule', '');
        b.setAttribute('data-start', p.s || ''); b.setAttribute('data-end', p.e || '');
        b.setAttribute('data-days', p.d || ''); b.setAttribute('data-from', p.f || ''); b.setAttribute('data-to', p.to || '');
        if (p.w) b.setAttribute('data-week', p.w);
        b.hidden = true;
        b.style.setProperty('--b-bg', p.bg); b.style.setProperty('--b-fg', p.fg);
        if (p.i) b.innerHTML = p.i;
        var txt = document.createElement('span'); txt.textContent = p.t; b.appendChild(txt);
        host.appendChild(b);
      });
    });
  }
  function apply() {
    renderPromos();
    var design = window.Shopify && window.Shopify.designMode;
    var n = now();
    document.querySelectorAll('[data-schedule]').forEach(function (el) {
      el.hidden = design ? false : !isActive(el, n);
    });
    document.querySelectorAll('[data-schedule-group]').forEach(function (g) {
      g.hidden = design ? false : !g.querySelector('[data-schedule]:not([hidden])');
    });
  }
  var t;
  function soon() { clearTimeout(t); t = setTimeout(apply, 60); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
  setInterval(apply, 30000);
  if ('MutationObserver' in window) {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) { if (list[i].addedNodes.length) { soon(); return; } }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', function () { promos = null; document.querySelectorAll('[data-promo-done]').forEach(function (h) { h.removeAttribute('data-promo-done'); h.innerHTML = ''; }); apply(); });
  window.icaseSchedule = apply;
})();
